import { markRaw } from "vue";

import IllustrationCalendar from "./IllustrationCalendar.vue";
import IllustrationCard from "./IllustrationCard.vue";
import IllustrationDocumentAndPen from "./IllustrationDocumentAndPen.vue";
import IllustrationDocuments from "./IllustrationDocuments.vue";
import IllustrationEncryptedDoc from "./IllustrationEncryptedDoc.vue";
import IllustrationGraph from "./IllustrationGraph.vue";
import IllustrationLetter2 from "./IllustrationLetter2.vue";
import IllustrationLetter from "./IllustrationLetter.vue";
import IllustrationPeople from "./IllustrationPeople.vue";
import IllustrationPieChart from "./IllustrationPieChart.vue";
import IllustrationReport2 from "./IllustrationReport2.vue";
import IllustrationReport3 from "./IllustrationReport3.vue";
import IllustrationReport from "./IllustrationReport.vue";
import IllustrationSearch from "./IllustrationSearch.vue";
import IllustrationStar from "./IllustrationStar.vue";
import IllustrationTickets from "./IllustrationTickets.vue";

export default {
  calendar: markRaw(IllustrationCalendar),
  card: markRaw(IllustrationCard),
  document_and_pen: markRaw(IllustrationDocumentAndPen),
  documents: markRaw(IllustrationDocuments),
  encrypted_doc: markRaw(IllustrationEncryptedDoc),
  graph: markRaw(IllustrationGraph),
  letter: markRaw(IllustrationLetter),
  letter2: markRaw(IllustrationLetter2),
  people: markRaw(IllustrationPeople),
  pie_chart: markRaw(IllustrationPieChart),
  report: markRaw(IllustrationReport),
  report2: markRaw(IllustrationReport2),
  report3: markRaw(IllustrationReport3),
  search: markRaw(IllustrationSearch),
  star: markRaw(IllustrationStar),
  tickets: markRaw(IllustrationTickets),
};
